import { ActionYd } from "./ActionYd.js";
import { Annotation } from "./Annotation.js";

export class AnnotationYd3 extends Annotation {
    constructor(args = {}) {
        super(args)

        this._data = args.data || null
        this._title_h = args.hoverTitle || ''
        this._isNormal = args.isNormal || false
        this.isRobot = args.isRobot || false
        this.opacity = 1
        this.isAlreadyClicked = false
        this._icon = args.icon
        // let iconClose = exports.resourcePath + '/icons/annotation_bg.png'
        this.extraParams = args.extraParams

        // 走基类 _setDomElement 而非直接赋值：替换后需按 _display 同步新元素的显隐，
        // 否则构造末尾 super 里的 display=false 只隐藏了被丢弃的基类元素（详见该方法注释）
        this._setDomElement($(`
                  <div class="yd-annotation-sxt3" oncontextmenu="return false;">
                    <div class="yd-sxt-img3"></div>
                  </div>
              `))

        this.imgdom = document.createElement('img')
        this.imgdom.src = this._icon
        this.imgdom.style.width = args.imgWidth || '32px'
        this.imgdom.style.height = args.imgHeight || '80px'

        this.ydsxtimg = this.domElement.find('.yd-sxt-img3')
        this.ydsxtimg.append(this.imgdom)

        this.actions = this.actions.map((a) => {
            if (a instanceof ActionYd) {
                return a
            } else {
                return new ActionYd(a)
            }
        })

        for (let action of this.actions) {
            // this.elTitlebar.click(() => action.onclick({ annotation: this }))
            this.ydsxtimg.click(() => action.onclick(this))
        }
    }

    setOpacity(opacity = 1) {
        if (this.ydsxtimg) {
            this.opacity = opacity
            this.ydsxtimg[0].style.opacity = opacity
        }
    }

    dispose() {
        // 解绑点击事件，置空 img 引用，帮助 GC
        if (this.ydsxtimg) {
            this.ydsxtimg.off()
        }
        this.imgdom = null
        this.ydsxtimg = null

        super.dispose()
    }
}